"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.array.index-of");

require("core-js/modules/es.function.name");

require("core-js/modules/es.object.assign");

require("core-js/modules/es.object.keys");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Control = _interopRequireDefault(require("../../elements/Control"));

var _mapToCssModules = _interopRequireDefault(require("../../utils/mapToCssModules"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * A text input component. Can be used for most 'text style' inputs such as password, number, tel etc.
 */
var Text = function Text(_ref) {
  var cssModule = _ref.cssModule,
      className = _ref.className,
      id = _ref.id,
      name = _ref.name,
      placeholder = _ref.placeholder,
      inlinePlaceholder = _ref.inlinePlaceholder,
      isInline = _ref.isInline,
      required = _ref.required,
      requiredText = _ref.requiredText,
      preAddon = _ref.preAddon,
      postAddon = _ref.postAddon,
      label = _ref.label,
      labelProps = _ref.labelProps,
      tooltip = _ref.tooltip,
      tooltipProps = _ref.tooltipProps,
      helpText = _ref.helpText,
      error = _ref.error,
      status = _ref.status,
      statusMessage = _ref.statusMessage,
      width = _ref.width,
      value = _ref.value,
      attrs = _objectWithoutProperties(_ref, ["cssModule", "className", "id", "name", "placeholder", "inlinePlaceholder", "isInline", "required", "requiredText", "preAddon", "postAddon", "label", "labelProps", "tooltip", "tooltipProps", "helpText", "error", "status", "statusMessage", "width", "value"]);

  var _status = status;
  var _statusMessage = statusMessage;

  if (error) {
    _status = 'error';
    _statusMessage = error;
  }

  var isInvalid = _status === 'error';
  var inputClasses = (0, _mapToCssModules.default)((0, _classnames.default)('text-input', _defineProperty({}, "text-input--".concat(_status), !!_status)), cssModule);
  var inputId = id || name;
  var optionalInputAttributes = {};

  if (_statusMessage) {
    optionalInputAttributes['aria-describedby'] = "".concat(inputId, "-status-msg");
  }

  return /*#__PURE__*/_react.default.createElement(_Control.default, {
    cssModule: cssModule,
    className: className,
    name: inputId
    /*
     * Placeholder is intentionally prevented from being passed to the <input> element here.
     * Best practices require field formatting information to be placed next to the label instead of inside the field
     * See jira issue EST21-2171 for more information.
     */
    ,
    placeholder: placeholder,
    isInline: isInline,
    label: label,
    labelProps: labelProps,
    tooltip: tooltip,
    tooltipProps: tooltipProps,
    helpText: helpText,
    required: required,
    requiredText: requiredText,
    width: width,
    status: _status,
    statusMessage: _statusMessage
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: inputClasses
  }, preAddon && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _mapToCssModules.default)('text-input__pre', cssModule)
  }, preAddon), /*#__PURE__*/_react.default.createElement("input", _extends({
    id: inputId,
    name: name,
    value: value,
    required: required,
    "aria-required": required,
    "aria-invalid": isInvalid // Not recommended, see EST21-2171
    ,
    placeholder: inlinePlaceholder
  }, optionalInputAttributes, attrs)), postAddon && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _mapToCssModules.default)('text-input__post', cssModule)
  }, postAddon)));
};

Text.defaultProps = {
  className: undefined,
  isInline: false,
  id: undefined,
  placeholder: null,
  required: false,
  preAddon: undefined,
  postAddon: undefined,
  label: undefined,
  labelProps: {},
  inlinePlaceholder: undefined,
  tooltip: undefined,
  tooltipProps: {},
  helpText: undefined,
  error: undefined,
  status: undefined,
  statusMessage: undefined,
  width: undefined,
  cssModule: undefined,
  requiredText: undefined,
  value: ''
};
Text.propTypes = {
  className: _propTypes.default.string,

  /**
   * name will be used as the input's id if it's not provided.
   */
  id: _propTypes.default.string,

  /**
   * The name of the input, will also be used as the id if no id is provided.
   */
  name: _propTypes.default.string.isRequired,
  placeholder: _propTypes.default.string,
  inlinePlaceholder: _propTypes.default.string,

  /**
   * The label of the control.
   */
  label: _propTypes.default.node,

  /**
   * Props to be passed to the label
   */
  labelProps: _propTypes.default.object,

  /**
   * The content of the controls tooltip.
   */
  tooltip: _propTypes.default.node,

  /**
   * Props to be passed to the tooltip
   */
  tooltipProps: _propTypes.default.object,

  /**
   * Help text to display below the field.
   */
  helpText: _propTypes.default.node,

  /**
   * Display something to the left of the field
   */
  preAddon: _propTypes.default.node,

  /**
   * Display something to the right of the field
   */
  postAddon: _propTypes.default.node,

  /**
   * If true, the control will use an inline layout
   */
  isInline: _propTypes.default.bool,
  error: _propTypes.default.node,
  status: _propTypes.default.oneOf(['error', 'warning', 'info', 'success']),
  statusMessage: _propTypes.default.node,
  required: _propTypes.default.bool,

  /**
   * Will be full width if not specified
   */
  width: _propTypes.default.oneOf(['xl', 'l', 'm', 's', 'xs', 'xxs']),
  cssModule: _propTypes.default.object,
  requiredText: _propTypes.default.func,
  value: _propTypes.default.string
};
var _default = Text;
exports.default = _default;
//# sourceMappingURL=Text.js.map